import React from 'react';
import styles from '@/styles/components/question-builders/base/TemplatedContentElement.module.css';
import _ from 'lodash';
import { EditText } from 'components/EditText';

export interface TemplateElementData {
  value: string | null;
  rteValue?: string | null;
  placeholder?: string;
  onChange?: (text: string | null, rteText?: string | null) => void;
}

export interface TemplateContentElementData {
  templateType: 'text' | 'template';
  templateData: TemplateElementData[];
  parentFocus?: boolean;
}

export const TemplateContentElement: React.FC<TemplateContentElementData> = ({
  templateType,
  templateData,
  parentFocus,
}) => {
  return (
    <div className={`${styles.wrapper} ${styles[templateType + 'Type']}`}>
      {_.map(templateData, (d, index) =>
        d.onChange ? (
          <EditText
            key={index}
            {...d}
            onChange={d.onChange}
            parentFocus={parentFocus}
          />
        ) : (
          <span key={index} className={styles.text}>
            {d.value}
          </span>
        )
      )}
    </div>
  );
};
